const initialState = {
    appName: "ALL BLOGS ARE HERE",
};

const appInfoReducer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export default appInfoReducer;
